export const SAVE_NODES_DATA = 'ethstats/nodesData/SAVE_NODES_DATA';
